import React from "react";

export const CaptchaPolicy = () => (
  <span className="font-light text-xs text-dark">
    This site is protected by reCAPTCHA and the Google{" "}
    <u>
      <a href="https://policies.google.com/privacy">Privacy Policy</a>
    </u>{" "}
    and{" "}
    <u>
      <a href="https://policies.google.com/terms">Terms of Service</a>
    </u>{" "}
    apply.
  </span>
);
